import { Block } from "@components/block";
import { CustomSelect, SelectOption } from "@components/select";
import { Table } from "@components/table";
import { useWallets } from "@features/wallets";
import { useWithdrawals } from "@features/withdrawals";
import { usePagination } from "@hooks/use-pagination";
import { withdrawalsConfig } from "../../merchant/payouts";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

type IFilter = {
  wallets: string;
};
export const LeadWithdrawalsPage = () => {
  const { state: withdrawalsState, getWithdrawals } = useWithdrawals();
  const { state: walletState, getWallets } = useWallets();
  const [walletOptions, setWalletOptions] = useState<SelectOption[]>([]);
  const { page, limit, setPage, setLimit } = usePagination(100);
  const { control, watch } = useForm<IFilter>();
  useEffect(() => {
    getWithdrawals({ wallets: watch("wallets") });
  }, [watch("wallets")]);

  useEffect(() => {
    getWithdrawals({ page, limit });
  }, [getWithdrawals, page, limit]);

  useEffect(() => {
    getWallets();
  }, [getWallets]);
  useEffect(() => {
    if (walletState.wallets) {
      const options = walletState.wallets
        .map((wallet) => ({
          value: wallet.address,
          text: wallet.address,
        }))
        .filter((option) => option.value.length > 0);

      setWalletOptions(options);
    }
  }, [walletState.wallets]);
  return (
    <Block>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          alignItems: "center",
        }}
      >
        <h3>История выводов</h3>
        <CustomSelect
          name="wallets"
          control={control}
          options={walletOptions}
          placeholder="Адрес"
        />
      </div>
      <Table
        config={withdrawalsConfig}
        data={withdrawalsState.withdrawals}
        loading={withdrawalsState.loading}
        setPage={setPage}
        setLimit={setLimit}
        page={page}
        limit={limit}
        limits={[100, 200, 300]}
      />
    </Block>
  );
};
